import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import { TextFilter, HistoricalComboAthlete, CountryCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class FilterCoachesService extends FiltersAbstractService {
    constructor(http) {
        super();
        this.http = http;
        this.textFilter = new TextFilter('text');
        this.activeCombo = new HistoricalComboAthlete('Status:', 'currentcombo', undefined, [{ item: { Name: 'All', Value: undefined }, position: 0 }, { item: { Name: 'Current', Value: true },
                position: 1 }, { item: { Name: 'Historical:', Value: false } }]);
        this.countryCombo = new CountryCombo('Country:', 'country-combo', this.http, [{ item: { CShort: 'All' }, position: 0 }], 'country', true, true);
        this.nationalityCombo = new CountryCombo('Nationality:', 'nationality-combo', this.http, [{ item: { CShort: 'All' }, position: 0 }], 'nationality', true, true);
        /**
         * Filters of coaches service
         *
         * @memberof FilterCoachesService
         */
        this.filtersType = [
            this.textFilter.filterInfo,
            this.nationalityCombo.filterInfo,
            this.countryCombo.filterInfo,
            this.activeCombo.filterInfo,
        ];
    }
    /**
     *
     *
     * @memberof FilterCoachesService
     */
    generateDefaultValues() {
    }
    /**
     * Filter data of coaches service
     *
     * @returns
     * @memberof FilterCoachesService
     */
    getDataStreamWithFilters() {
        return combineLatest([
            this.orderSubject,
            this.textFilter.data(),
            this.activeCombo.comboData,
            this.countryCombo.comboData.pipe(filter(a => a != undefined)),
            this.nationalityCombo.comboData.pipe(filter(a => a != undefined))
        ]);
    }
}
FilterCoachesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterCoachesService_Factory() { return new FilterCoachesService(i0.ɵɵinject(i1.HttpClient)); }, token: FilterCoachesService, providedIn: "root" });
